export function routeIsList(route) {
  const getSuccessRes = route.methods?.get?.responses?.[200]?.content?.['application/json']?.schema;
  const resolvedSchema = resolveSchema(getSuccessRes);
  // if one of the response keys is an array of a blueprint
  return !!Object.values(resolvedSchema?.properties || {}).find(val => val?.type === 'array' && val?.items['x-lev-object-type']);
}
export function routeIsItem(route) {
  const getSuccessRes = route.methods?.get?.responses?.[200]?.content?.['application/json']?.schema;
  const resolvedSchema = resolveSchema(getSuccessRes);
  return !!resolvedSchema?.['x-lev-object-type'];
}
export function resolveSchema(schema) {
  if (!schema) {
    return schema;
  }
  if (schema.allOf) {
    const toReturn = {
      type: 'object',
      properties: {}
    };
    schema.allOf.forEach(schemaPiece => {
      if (schemaPiece?.properties) {
        toReturn.properties = {
          ...toReturn.properties,
          ...schemaPiece.properties
        };
      }
    });
    return toReturn;
  }
  return schema;
}
export function toOpenApiPath(urlPath, cxt) {
  return `${cxt?.options?.basePath ? cxt.options.basePath : ''}${urlPath.replace(/\/:([a-zA-z0-9]*)/g, '/{$1}')}`;
}